import styled, { css } from 'styled-components';

import { Button as FormButton, TextField as TextFieldForm } from '@components/form';
import { media } from '@theme/media';
import { FONT_SIZE, LETTER_SPACING, typography } from '@theme/font';

export const buttonFontStyles = css`
  ${typography({ size: FONT_SIZE.M, spacing: LETTER_SPACING.S })};
`;

export const TextField = styled(TextFieldForm)`
  margin-top: 70px;

  label {
    min-width: 80px;
    align-items: center;
  }
  height: 51px;

  input,
  label {
    ${buttonFontStyles};
  }

  ${media.tablet} {
    label {
      display: flex;
    }
  }
`;

export const Button = styled(FormButton)`
  ${buttonFontStyles};
  padding: 14px 10px;
`;

export const Balance = styled.h3`
  ${typography({ size: FONT_SIZE.M, spacing: LETTER_SPACING.S })};
  margin-top: 70px;
`;
